var _rect, _rect2, _rect3, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCardPhysical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 54,
    viewBox: "0 0 78 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "svg-dark-stroke",
    x: 4,
    y: 5,
    width: 70,
    height: 44,
    rx: 6,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "svg-dark-fill",
    x: 4,
    y: 12,
    width: 70,
    height: 8,
    fill: "#1a1a1a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "svg-primary-stroke svg-primary-light-fill",
    x: 12,
    y: 28,
    width: 38,
    height: 11,
    rx: 3,
    fill: "#FFF2F1",
    stroke: "#E2231A",
    strokeWidth: 1.6,
    strokeDasharray: "3 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-primary-stroke",
    d: "M17 33.5h5M25 33.5h5M33 33.5h5M41 33.5h4",
    stroke: "#E2231A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "svg-primary-fill",
    cx: 62,
    cy: 34,
    r: 5,
    fill: "#E2231A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardPhysical);
export default __webpack_public_path__ + "static/media/gift-card-physical.81acc8cfccf58ef2b7402ae0405df4bd.svg";
export { ForwardRef as ReactComponent };